module.exports = __webpack_public_path__ + "img/tablo_hover_97ca291.png";